import { KeyValue } from '../../common/redux/api/web-api'
import { IConnectorId } from '../../ui/ConnectorSelect'
import { MAX_SAFE_CURRENT } from '../../ui/CurrentSelect'

export enum CurrentLimitType {
    MAX_CURRENT = 'MaxCurrent',
    INSTALLATION_CURRENT = 'InstallationCurrent',
    USER_CURRENT_LIMIT = 'UserCurrentLimit',
}

export const getConnectorCurrentLimitFromConfig = (
    configKeys: Array<KeyValue>,
    currentLimitType: CurrentLimitType,
    connectorId: IConnectorId
): number => {
    const currentLimitConfig = configKeys.find((config) => config.key === currentLimitType)
    if (!currentLimitConfig) return MAX_SAFE_CURRENT

    const limits: { [key: string]: number } = currentLimitConfig.value
        .split(',')
        .map((connectorValue) => connectorValue.split('.'))
        .reduce((limits, [key, strLimit]) => Object.assign(limits, { [key]: parseInt(strLimit) }), {})

    return limits[connectorId] || limits[0] || MAX_SAFE_CURRENT
}
